import React, { useContext, useEffect, useState } from 'react';
import { BreadCrumb } from 'primereact/breadcrumb';
import { useLocation } from 'react-router-dom';
import Toolbar from './Toolbar/Toolbar';
import { AppContext } from '../UI/contexts';
import PageNotFound from '../UI/PageNotFound/PageNotFound';
import './Layout.css';

function Layout(props) {
  const [breadcrumbItems, setBreadcrumbItems] = useState([]);
  const location = useLocation();

  // Get the path name and convert to readable label
  const getPathLabel = (path) => {
    if (path === '/') return '';
    if (path === 'trfx-run-tests') return 'Create Execution (TRFX)';
    if (path === 'trfx-run-tests-edit') return 'Edit Execution (TRFX)';
    if (path === 'atc-run-tests-edit') return 'Edit Execution (aTC)';
    if (path === 'atc-run-tests') return 'Create Execution (aTC)';
    if (path === 'add-url') return 'Add Url (TRFX)';
    if (path === 'edit-url') return 'Edit Url (TRFX)';
    if (path === 'delete-url') return 'Delete Url (TRFX)';
    if (path === 'add-feature') return 'Add feature';
    if (path === 'delete-feature') return 'Delete feature';
    if (path === 'custom-scopes-processing-queue') return 'Processing queue';
    if (path === 'view-custom-scopes') return 'View custom scopes';
    if (path === 'trfx-test-executions') return 'Test Executions (TRFX)';
    if (path === 'trfx-show-test-results')
      return 'Test Executions show result (TRFX)';
    if (path === 'atc-show-test-results')
      return 'Test Executions show result (aTC)';
    if (path === 'atc-test-executions') return 'Test Executions (aTC)';
    if (path === 'associate-component') return 'Associate Customer';
    if (path === 'schedule') return 'Schedule';
    return path.charAt(0).toUpperCase() + path.slice(1).replace(/-/g, ' ');
  };

  // Update breadcrumb items when URL changes
  useEffect(() => {
    // Skip the first character (the /)
    const pathSegments = location.pathname.substring(1).split('/');
    if (pathSegments[0] === '') {
      // We're at home, no breadcrumb needed
      setBreadcrumbItems([]);
      return;
    }

    const items = [];
    let currentPath = '';

    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const label = getPathLabel(segment);

      // If it's the last segment, no URL
      if (index === pathSegments.length - 1) {
        items.push({ label });
      } else {
        items.push({
          label,
          url: currentPath,
        });
      }
    });

    setBreadcrumbItems(items);
  }, [location.pathname]);

  // Add class to body for home page
  useEffect(() => {
    if (location.pathname === '/') {
      document.body.classList.add('home-page');
    } else {
      document.body.classList.remove('home-page');
    }
  }, [location.pathname]);

  const { user } = useContext(AppContext);
  return user._id !== 'invalidUser' ? (
    <>
      <Toolbar />

      <div
        className={`layout-content ${
          location.pathname === '/' ? 'home-page' : ''
        }`}
      >
        {location.pathname !== '/' && (
          <div className='layout-breadcrumb-container'>
            <BreadCrumb
              id='att-breadcrumb'
              model={breadcrumbItems}
              home={{ icon: 'pi pi-home', url: '/' }}
              className='layout-breadcrumb'
            />
          </div>
        )}
        {props.children}
      </div>
    </>
  ) : (
    <PageNotFound />
  );
}
export default Layout;
